import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { HeaderTypeTokens, SizeTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { goBack } from "./actions";
import { getPrivacyLinks, getTclLink, getTermsLinks } from "../../configs/utils";
import { Platform } from "react-native";
export const template = (isTerms, isTcl) => ({
    layout: {
        id: ROUTE.PRIVACY_POLICY,
        type: LAYOUTS.LIST,
        widgets: [
            Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            { id: "headerStack", type: WIDGET.HEADER, position: POSITION.ABSOLUTE_TOP },
            { id: "webview", type: WIDGET.WEB_VIEW }
        ],
    },
    datastore: {
        headerStack: {
            id: 'bt_termsAndConditions_goBack',
            leadIcon: "https://reactnative.dev/img/tiny_logo.png",
            title: isTerms ? "Terms & Conditions" : isTcl ? 'Lending partners' : "Privacy Policy",
            isBackButton: true,
            type: HeaderTypeTokens.DEFAULT,
            action: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.PRIVACY_POLICY,
                payload: {},
            },
        },
        webview: {
            uri: isTerms
                ? getTermsLinks()
                : isTcl ? getTclLink()
                    : getPrivacyLinks(),
            isOpenInNewTab: false,
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        }
    },
});
export const privacyPolicyMF = {
    onLoad: async ({ ...props }, { isTerms, isTcl }) => {
        return Promise.resolve(template(isTerms, isTcl));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
    },
};
